export default __webpack_public_path__ + "static/media/gtd10.a17b2dcd.jpg";